import { Directive, Input, HostListener } from '@angular/core';

import { LzLogService } from "../services/lz-log.service";

@Directive({
  selector: '[lzLog]'
})

export class LzLogDirective {

  @Input() lzLog: string;

  @HostListener('click', []) clickEvent() {
    this.send();
  }

  constructor(private log: LzLogService) {}

  send = () => {
    this.log.logForHadoop(this.lzLog, {});
  }

}
